const KEY = "xq_current_user";

// Called once, right after a successful login.
export function setCurrentUser(user) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify(user));
    } catch {
        // ignore storage errors (e.g. private browsing)
    }
}

// Who is logged in, or null if unknown (e.g. page was opened directly
// without going through the login form). Shape depends on how they signed in:
//   executive  -> { executive_id, executive_name }   (normal case)
//   legacy user-> { user_id, user_name }             (order-app user; see LoginDropdown)
// Leads / Service Calls record `executive_id`; it is undefined for a legacy user.
export function getCurrentUser() {
    try {
        const raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function clearCurrentUser() {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        // ignore
    }
}